import React from "react";
import Couple from "../../utils/images/footer-rsvp.jpg";
import { HeartFilled } from "@ant-design/icons";
import { HeartStyle } from "../data/data";
import styled from "styled-components";

const Layout = styled.div`
  .name {
    font-size: 35px;
    font-family: sans-serif;
    margin: 22px 0;
  }
`;
function RsvpFooter() {
  return (
    <>
      <Layout>
        <div style={styles.bgParallax}>
          <span style={styles.text}>
            Thank
            <span> you</span>
          </span>
          <HeartStyle>
            <span className="white-line"></span>
            <HeartFilled style={{ fontSize: 19, zIndex: 20, color: "red" }} />
            <HeartFilled
              style={{
                fontSize: 19,
                marginLeft: -5,
                color: "white",
              }}
            />
            <span className="white-line"></span>
          </HeartStyle>
          <p>
            <span className="name">Victor & Ufedo</span>
          </p>
        </div>
      </Layout>
    </>
  );
}

const styles = {
  bgParallax: {
    background: `url(${Couple})`,
    height: 450,
    backgroundSize: "cover",
    objectFit: "cover",
    opacity: 0.8,
    display: "flex",
    flexDirection: "column",
    justifyContent: "Center",
    alignItems: "center",
    color: "white",
  },
  text: {
    fontSize: 55,
    transform: "rotate(-10deg)",
    color: "white",
    fontFamily: "sans-serif ",
  },
};

export default RsvpFooter;
